import { reactive } from "vue";
const state = reactive({
   templateReplyTypeList: [
      { label: 'Quick Reply Button', value: 1 },
      { label: 'Static Link Button', value: 2 },
      { label: 'Dynamic Link Button', value: 3 },
      { label: 'Mobile Number', value: 4 },
      { label: 'Email', value: 5 },
      { label: 'Aadhar Number', value: 6 },
      { label: 'Voter Id', value: 7 },
      { label: 'Pancard', value: 8 },
      { label: 'Driving Licence', value: 9 },
      { label: 'Vehicle Number', value: 10 },
      { label: 'Image', value: 11 },
      { label: 'Video', value: 12 },
      { label: 'OTP', value: 13 },
      { label: 'Text', value: 14 },
      { label: 'PDF or Word file', value: 15 },
      { label: 'Contact', value: 16 },
      { label: 'Location', value: 17 },
      { label: 'Dropdown', value: 18 },
      { label: 'Date', value: 19 },
      { label: 'Radio Button', value: 20 },
      { label: 'Passport Number', value: 21 },  
      { label: 'Stop Chatbot', value: 22 },
 
   ],
   ChannelIdList: [
      { label: 'WhatsApp', value: 1 },
      { label: 'RCS', value: 2 },
      { label: 'Sms', value: 3 },
      { label: 'Email', value: 4 },
   ],
   headerFileTypeList: [
      { label: 'Image', value: 1 },
      { label: 'Document', value: 2 },
      { label: 'Video', value: 3 },
      { label: 'Audio', value: 4 },
   ],
   actionTakingList: [
      { value: 1, label: 'Action Taking User' },
      { value: 2, label: 'Admin User' },
      { value: 3, label: 'Support User' },
      { value: 4, label: 'Citizen' },
      { value: 5, label: 'Current User' }
   ],
   documentTypes: [
      { value: 1, label: "Appointment letter of admin" },
      { value: 2, label: "Appointment letter of owner" },
      { value: 3, label: "Appointment letter of co-ordinator" },
      { value: 4, label: "Purchase Order" },
      { value: 5, label: "Technical Information" },
      { value: 6, label: "Other" },
   ],
   actionTakingListForAdmin: [
      { value: 1, label: 'Owner' },
      { value: 2, label: 'Admin' },
      { value: 3, label: 'Co-ordinator' },
      { value: 4, label: 'Billing' }
   ],

   //cloud telephony virtual number status, operator list
   statusList: [
      { value: "0", label: "Free" },
      { value: "1", label: "Active" },
      { value: "2", label: "Under admin notice period" },
      { value: "3", label: "request submited to operator" },
      { value: "4", label: "Release Number" },
   ],
   operatorList: [
      { value: "1", label: "Vodafone" },
      { value: "2", label: "Idea" },
      { value: "3", label: "Airtel" },
      { value: "4", label: "Not Known" },
      { value: "5", label: "BSNL" },
      { value: "6", label: "Jio" },
      { value: "7", label: "TATA" },
      { value: "8", label: "Reliance" },
   ],
});

export default { state };